import { useContext } from 'react';
import { NavigationGuardContext } from '@app/app/_context/NavigationGuardContext/NavigationGuardContext';

export function useNavigationGuard() {
    return useContext(NavigationGuardContext);
}
